import { render, staticRenderFns } from "./Optativa.vue?vue&type=template&id=1a0c4f91&scoped=true"
import script from "./Optativa.vue?vue&type=script&lang=js"
export * from "./Optativa.vue?vue&type=script&lang=js"
import style0 from "./Optativa.vue?vue&type=style&index=0&id=1a0c4f91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0c4f91",
  null
  
)

export default component.exports